import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subject, takeUntil} from 'rxjs';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../state/app.state';
import {FormControl, FormGroup} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonService} from "../../../shared/services/common.service";
import { profile } from 'src/app/modules/shared/core/shared.selectors';
import { roles } from 'src/app/modules/shared/constants/common.constants';
import { CoachGroupsListService } from '../service/coach-groups-list.service';
import { GenerateAttendanceReportRequest } from '../core/coach-groups-list.actions';
import { groupsList } from '../core/coach-groups-list.selectors';
import {DownloadAttendanceReportModalComponent} from '../components/download-attendance-report-modal/download-attendance-report-modal.component';

@Component({
  selector: 'app-coach-groups-list-screen',
  templateUrl: './coach-groups-list-screen.component.html',
  styleUrls: ['./coach-groups-list-screen.component.css'],
})
export class CoachGroupsListScreenComponent implements OnInit, OnDestroy {
  searchForm: FormGroup = new FormGroup({
    search: new FormControl(``),
  });
  private readonly onDestroy: Subject<any> = new Subject<any>();
  panel: boolean = true;
  loggedInUserProfileStatus: number = null;
  loggedInUserRoleKey :number = null;
  roleMap=roles;
  shownDataCount: number= null;

  isDrilldown = false;

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
    private coachGroupsListService: CoachGroupsListService,
  ) {
  }

  ngOnInit(): void {
    this.commonService
      .onNavigationEnd
      .pipe(takeUntil(this.onDestroy))
      .subscribe(d => {
        const params: any = this.route.snapshot.params;
        const queryParams: any = this.route.snapshot.queryParams;

        if(params.coachId || params.clientAdminId || params.memberId) {
          this.isDrilldown = true;
        }

        const urlParams = {
          params,
          queryParams
        }

        const prevUrlParams = this.commonService.urlParams.getValue();
        
        if (d.isRouteChanged || JSON.stringify(prevUrlParams) !== JSON.stringify(urlParams)) {
         this.commonService.urlParams.next(urlParams);
        }
      });

      this.store.select(groupsList).pipe(takeUntil(this.onDestroy)).subscribe(groupList=>{
        this.shownDataCount = groupList?.list?.length
      })
    this.store.select(profile).pipe(takeUntil(this.onDestroy)).subscribe((profileData: any)=>{
      this.loggedInUserProfileStatus = profileData?.status?.key;
      this.loggedInUserRoleKey = profileData?.role;
    })
  }

  onAddGroup() {
    const urlPrefix = this.router.url.split('/')[1];
    this.router.navigate([`/${urlPrefix}/group/create`]);
  }

  downloadReportClick(event){
    event.stopPropagation();
    // open add dialog
    this.commonService.openDialog({
      data: {
        component: DownloadAttendanceReportModalComponent,
        panelWidth: 20
      }
    })
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
